export default __webpack_public_path__ + "static/media/casco-bombero.9904b762.png";